import { gql, TypedDocumentNode } from '@common/hooks';
import {
  ScheduleGroupSkillsQueryCgResponse,
  ScheduleGroupSkillsQueryVariables,
} from '@common/graphql';

export const SCHEDULE_GROUP_SKILLS_QUERY: TypedDocumentNode<
  ScheduleGroupSkillsQueryCgResponse,
  ScheduleGroupSkillsQueryVariables
> = gql`
  query ScheduleGroupSkills($scheduleGroupId: ID!) {
    scheduleGroupSkills: serviceLineSkills(serviceLineId: $scheduleGroupId) {
      id
      name
      description
      archived
    }
  }
`;
